const path = 'api/Portal/Help'

const getParentList = (http) => {
    return http.get(`${path}/GetParentList`)
}

const getChildrenByParent = (http, parentId) => {
    return http.get(`${path}/GetChildrenByParent?ParentId=${parentId}`)
}

const saveParent = (http, parent) => {
    return http.post(`${path}/SaveParent`, parent)
}

const saveChild = (http, child, parentId) => {
    return http.post(`${path}/SaveChild?parentId=${parentId}`, child)
}

const deleteParent = (http, parentId) => {
    return http.delete(`${path}/DeleteParent?parentId=${parentId}`)
}

const deleteChild = (http, childId) => {
    return http.delete(`${path}/DeleteChild?childId=${childId}`)
}

export default {
    getParentList: getParentList,
    getChildrenByParent: getChildrenByParent,
    saveParent: saveParent,
    saveChild: saveChild,
    deleteParent: deleteParent,
    deleteChild: deleteChild
}
